import React from 'react'
import { ImageComp } from '../../Components/ImageCompo/ImageComp'
import HeaderCompo from '../../Components/HeaderComp/HeaderCompo'
import { ParagraphComp } from '../../Components/ParagraphComp/ParagraphComp'
import CustomInput from '../../Components/InputCompo/CustomInput'
import { InputCompo } from '../../Components/InputCompo/InputCompo'
import { Link } from 'react-router-dom'
import ButtonComp from '../../Components/ButtonComp/ButtonComp'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// import required modules
import { EffectFade, Pagination, Autoplay } from 'swiper/modules';

const NpoLogin = () => {
    // Npologin
    const CarouselImages = ['Frame 1000003230.png', '3.png', '2.png']
    return (
        <>

            <div className='h-[100vh] pt-[40px]  pb-[40px]'>
                <div className='w-[100%] h-[100%] flex justify-between'>
                    <div className='w-[40%] flex items-center justify-between h-[100%] gap-[30px]'>
                        <div className=''>
                            <ImageComp className='mt-[200px]' source='./Images/image 6.png' />
                        </div>
                        <div className='flex flex-col w-[70%] items-center gap-[35px]'>
                            <ImageComp className='h-auto w-[370px] object-cover  ' source='./Images/logo.png' />
                            <div className='w-[100%] flex flex-col items-center'>
                                <HeaderCompo className={'tracking-tighter font-bold mb-0 text-[60px] text-[#1C1C1C]'} text='WELCOME' tagType={'h1'} />
                                <ParagraphComp className={'text-[#1C1C1C]'} text='We are glad to see you back with us' />
                            </div>
                            <div className='h-auto flex w-[100%] flex-col gap-[15px]'>
                                <CustomInput label='Username' />
                                <CustomInput label='Password' />
                                <div className='flex justify-between'>
                                    <label className="flex items-center  space-x-2">
                                        <InputCompo required className='bg-[#004878] text-white w-[20px] h-[20px]' type='checkbox' />
                                        <span className='text-[#1C1C1C] font-bold'>Remember me</span>
                                    </label>
                                    <Link className='text-[#004878] font-bold'>Forgot Password ?</Link>
                                </div>
                                <div className='w-[100%] flex justify-center'>
                                    <ButtonComp text='Login' className='w-[188px] rounded-full h-[40px] bg-[#ED1C24] text-[white]' />
                                </div>
                                <div className='w-[100%] flex flex-col gap-[10px] mt-[30px] '>
                                    <ParagraphComp className={'text-[#1C1C1C] text-md leading-tight'} text='Want to register your organisation? Only ITPAN & Trust/ Society/ Sec 8 Co. (formerly sec 25) registration certificate required. ' />
                                    <Link className='text-[#004878]  font-bold'>Register here for free <ArrowForwardIcon className='text-[#004878]' /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-[50%] h-[100%] px-[40px] '>
                        <Swiper
                            spaceBetween={30}
                            effect={'fade'}
                            autoplay={{
                                delay: 2000
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[EffectFade, Pagination, Autoplay]}
                            className="relative w-full h-[100%]"  // Adjust height here
                        >
                            {CarouselImages.map((img, index) => (
                                <SwiperSlide key={index}>
                                    <ImageComp source={`./Images/${img}`} className='object-cover w-full h-[100%]' />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NpoLogin